import { useCallback } from "react";
import { useGetUserProfile } from "hooks/queries/use-get-user-profile.hook";
import type { MailingAddressFormValues } from "components/forms/mailing-address-section/mailing-address-section.component";
import { useUpdateUserProfile } from "./use-update-user-profile.hook";

export const useUpdateMailingAddress = () => {
  const { updateUserProfile, isLoading } = useUpdateUserProfile();
  const { data: rawProfileData } = useGetUserProfile();

  const updateMailingAddress = useCallback(
    async (values: MailingAddressFormValues) => {
      const existingLocations =
        (rawProfileData as any)?.userProfile?.locations || [];

      const defaultLocation = existingLocations.find(
        (loc: any) => loc.isDefault
      );
      const locationToUpdate = defaultLocation || existingLocations[0] || {};

      const updatedLocation = {
        ...locationToUpdate,
        address1: values.streetAddress,
        address2: values.aptSuiteUnit,
        city: values.city,
        state: values.state,
        postal: values.zipCode,
        type: "home",
      };

      const otherLocations = existingLocations.filter(
        (loc: any) => loc !== locationToUpdate && loc !== defaultLocation && loc
      );
      const locations = [updatedLocation, ...otherLocations];

      await updateUserProfile({
        locations,
      });
    },
    [updateUserProfile, rawProfileData]
  );

  return { updateMailingAddress, isLoading };
};
